<!--
  - SPDX-FileCopyrightText: 2015 Nextcloud GmbH and Nextcloud contributors
  - SPDX-License-Identifier: AGPL-3.0-or-later
-->
<template>
	<span :aria-hidden="!title"
		:aria-label="title"
		class="material-design-icon admin-icon"
		role="img"
		v-bind="$attrs"
		@click="$emit('click', $event)">
		<svg
			:fill="fillColor"
			:width="size"
			:height="size"
			enable-background="new 0 0 16 16"
			version="1.1"
			viewBox="0 0 16 16"
			xml:space="preserve"
			xmlns="http://www.w3.org/2000/svg">
			<path d="m6.9395 0.5c-0.24 0-0.43945 0.19945-0.43945 0.43945v1.2598c-0.5 0.14-1.0493 0.35039-1.5293 0.65039l-0.91016-0.91016c-0.16-0.18-0.46109-0.19-0.62109 0l-1.5 1.5c-0.18 0.17-0.18 0.46109 0 0.62109l0.91016 0.91016c-0.284 0.48-0.50039 0.9993-0.65039 1.5293h-1.2598c-0.24 0-0.43945 0.19945-0.43945 0.43945v2.1211c0 0.25 0.18945 0.43945 0.43945 0.43945h1.2598c0.14 0.54 0.36039 1.0493 0.65039 1.5293l-0.91016 0.91016c-0.18 0.17-0.18 0.45109 0 0.62109l1.5 1.5c0.18 0.18 0.46109 0.18 0.62109 0l0.91016-0.91016c0.48 0.285 0.9993 0.50039 1.5293 0.65039v1.2598c0 0.25 0.19945 0.43945 0.43945 0.43945h2.1211c0.24 0 0.44945-0.19945 0.43945-0.43945v-1.2598c0.54-0.14 1.0493-0.36039 1.5293-0.65039l0.91016 0.91016c0.17 0.18 0.45109 0.18 0.62109 0l1.5-1.5c0.18-0.17 0.18-0.45109 0-0.62109l-0.91016-0.91016c0.29-0.48 0.50039-0.9993 0.65039-1.5293h1.2598c0.24 0 0.44945-0.19945 0.43945-0.43945v-2.1211c0-0.24-0.19945-0.43945-0.43945-0.43945h-1.2598c-0.14-0.54-0.36039-1.0493-0.65039-1.5293l0.91016-0.91016c0.18-0.17 0.18-0.45109 0-0.62109l-1.5-1.5c-0.17-0.18-0.45109-0.18-0.62109 0l-0.91016 0.91016c-0.48-0.29-0.9993-0.50039-1.5293-0.65039v-1.2598c0-0.24-0.19945-0.43945-0.43945-0.43945h-2.1211zm1.0605 2.9922a4.5085 4.5085 0 0 1 4.5078 4.5078 4.5085 4.5085 0 0 1-1.082 2.9277c-0.073996-0.24227-0.18207-0.29128-0.45703-0.50195-0.65293-0.38819-1.456-0.69415-2.1387-0.95117-0.08904-0.3324-0.022553-0.5778 0.060547-0.89062 0.13949-0.14839 0.2973-0.2148 0.41602-0.35547 0.40956-0.52531 0.47461-1.44 0.47461-2.0781 0-0.94378-0.84935-1.6621-1.7812-1.6621-1.0387 0-1.7812 0.84892-1.7812 1.6621 0 0.831 0.059109 1.4252 0.47461 2.0781 0.11871 0.16976 0.2973 0.20708 0.41602 0.35547 0.08013 0.29679 0.14365 0.58196 0.060547 0.89062-0.7568 0.26711-1.4798 0.59503-2.1387 0.95117-0.29555 0.20862-0.39945 0.26205-0.46484 0.48633a4.5085 4.5085 0 0 1-1.0742-2.9121 4.5085 4.5085 0 0 1 4.5078-4.5078z" />
		</svg>
	</span>
</template>

<script>
export default {
	name: 'AdminIcon',
	props: {
		title: {
			type: String,
			default: '',
		},
		fillColor: {
			type: String,
			default: 'currentColor',
		},
		size: {
			type: Number,
			default: 24,
		},
	},
	emits: ['click'],
}
</script>
